// Shared grouping helpers for the indexed digital books (forScore + MobileSheets).
// Imported listings carry an explicit `platform` field; older Sanity products are
// recognised from their slug.

export function bookPlatform(p) {
  if (p.platform === 'forscore' || p.platform === 'mobilesheets') return p.platform;
  var slug = p.slug || '';
  return slug.indexOf('mobilesheets') !== -1 ? 'mobilesheets' : 'forscore';
}

export function isIndexedBook(p) {
  if (p.platform === 'forscore' || p.platform === 'mobilesheets') return true;
  var slug = p.slug || '';
  return /real-book|new-real-book|real-christmas|stamp|fake-?book|omnibook|arban|cookbook|gig-book|indexed|mobilesheets/.test(slug);
}

// A digital book's key tells you the instrument it is written for:
// C = piano/guitar, Bb = trumpet, Eb = alto sax, bass clef = trombone.
export var KEY_INSTRUMENT = { c: 'piano', bb: 'trumpet', eb: 'saxophone', bass: 'trombone' };

export function bookInstrument(p) {
  if (p.instrument) return p.instrument;
  return KEY_INSTRUMENT[bookKeyGroup(p)] || null;
}

// Books that are NOT written in a transposed key and have no key in the title
// (solo/etude collections). Everything else with no key shown is in C.
var NO_KEY_AUTHORS = /mendez|m.ndez|clifford|wynton|marsalis/i;

// Which transposition a book is for: bb | eb | bass | c | stamps | other
export function bookKeyGroup(p) {
  var override = (p.bookKey || '').toLowerCase();
  if (override) {
    if (override === 'none' || override === 'other') return 'other';
    return override;
  }
  var blob = ((p.slug || '') + ' ' + (p.name || '')).toLowerCase();
  if (/stamp/.test(blob)) return 'stamps';
  if (/bass/.test(blob)) return 'bass';
  if (/(^|[^a-z])bb([^a-z]|$)|-bb-|-bb$|in bb/.test(blob)) return 'bb';
  if (/(^|[^a-z])eb([^a-z]|$)|-eb-|-eb$|in eb/.test(blob)) return 'eb';
  if (/-c-|-c$|in c($|[^a-z])|concert/.test(blob)) return 'c';
  // Per the catalog rule: no key in the title means the book is in C, except
  // the Rafael Méndez / Clifford Brown / Wynton Marsalis collections.
  if (NO_KEY_AUTHORS.test(blob)) return 'other';
  return 'c';
}

export var PLATFORM_LABEL = { forscore: 'forScore', mobilesheets: 'MobileSheets' };

export function platformTextClass(platform) {
  return platform === 'mobilesheets' ? 'text-emerald-400' : 'text-sky-400';
}

export function platformBadgeClass(platform) {
  return platform === 'mobilesheets'
    ? 'bg-emerald-500/15 text-emerald-400 border border-emerald-500/40'
    : 'bg-sky-500/15 text-sky-400 border border-sky-500/40';
}

// Customer-facing title. The app name is carried by the badge, so strip it
// (and any "indexed for …" wording) out of the title itself.
export function displayBookName(p) {
  var name = (p && p.name) || '';
  if (!p || !isIndexedBook(p)) return name;
  var out = name
    .replace(/\([^()]*(?:forscore|for score|mobilesheets|mobile sheets)[^()]*\)/gi, '')
    .replace(/\b(?:indexed\s+)?(?:index\s+)?for\s+(?:forscore|for score|mobilesheets|mobile sheets)\b/gi, '')
    .replace(/\b(?:forscore|mobilesheets|mobile sheets)\b/gi, '')
    .replace(/\bindexed\b/gi, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/^[\s\-—–·|,:]+/, '')
    .replace(/[\s\-—–·|,:]+$/, '')
    .trim();
  return out || name;
}
